import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {useGetCardsQuery, useUpdateCardMutation} from '../../features/cards/api/cards-api';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';
import {Card} from '../../features/cards/types/Card';

const CardStatusToggle = ({card}:{card:Card}) => {
    const [
        updateCard, { isLoading, data: updatedCard }
    ] = useUpdateCardMutation();
    const status = updatedCard?.enabled ?? card.enabled;
    const onChange = ()=>  {
        updateCard({ id: card.id, enabled: !status });
    };
    if (isLoading) {
        return <CircularProgress size={33} />;
    }
    return <Switch defaultChecked={status} onChange={onChange} />;
};

export default function CardsManagement() {
    const { data, error, isLoading, refetch, isUninitialized, isFetching } = useGetCardsQuery();

    if (isLoading || isUninitialized || isFetching) {
        return <CircularProgress />;
    }

    if (error) {
        return <Button variant="contained" onClick={refetch}>
            Retry
        </Button>;
    }

    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell align="right">Display in board</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.items.map((row) => (
                        <TableRow
                            key={row.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {row.name}
                            </TableCell>
                            <TableCell align="right">
                                <CardStatusToggle card={row} />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}